export enum BOOKING_SUMMARY_STEPS {
    form = 'form',
    summary = 'summary'
}

export const BOOKING_SUMMARY_LOCAL_STORAGE = 'bookingSummary';
